import { memo } from 'react';
import { NodeProps } from '@xyflow/react';
import { LocationMarker } from '@lp/features/RoutePlanner/components/RouteViewList/LocationMarker';
import { SegmentTypeEnum } from '@/api/apis/route';
import { AirportNodeProps } from './AirportNode';
import { NodeHandleConnections } from './NodeHandleConnections';

export const AltAirportNode = memo(({ data }: NodeProps<AirportNodeProps>) => {
  return (
    <NodeHandleConnections>
      <LocationMarker variant="outlined" type="start" segmentType={SegmentTypeEnum.reposition} useMonoFont>
        {data.title}
      </LocationMarker>
    </NodeHandleConnections>
  );
});
